import { createContext, useContext, useEffect, useState } from "react";

const RegionContext = createContext(null);

const REGIONS = {
  usa: {
    id: "usa",
    label: "United States",
    flag: "🇺🇸",
    code: "US",
    dispatcherName: "Charles",
    dispatcherPhone: "+1 443-683-6392",
    dispatcherPhoneHref: "+14436836392",
    dispatcherWhatsapp: "14436836392",
    priceMultiplier: 1.0,
    accent: "#D4AF37",
    defaultPaymentMode: "online",
  },
  liberia: {
    id: "liberia",
    label: "Liberia",
    flag: "🇱🇷",
    code: "LR",
    dispatcherName: "Ralph",
    dispatcherPhone: "+231 77 768 9123",
    dispatcherPhoneHref: "+231777689123",
    dispatcherWhatsapp: "231777689123",
    priceMultiplier: 0.6,
    accent: "#D4AF37",
    defaultPaymentMode: "reserve",
  },
};

export const RegionProvider = ({ children }) => {
  const [region, setRegionState] = useState(() => {
    return localStorage.getItem("rx_region") || "usa";
  });

  const setRegion = (r) => {
    localStorage.setItem("rx_region", r);
    setRegionState(r);
  };

  const meta = REGIONS[region];

  return (
    <RegionContext.Provider value={{ region, setRegion, meta, all: REGIONS }}>
      {children}
    </RegionContext.Provider>
  );
};

export const useRegion = () => useContext(RegionContext);

export const REGION_LIST = Object.values(REGIONS);
